<div>

  <br/>

  <!-- Search -->
  <div class="section-search">
    <div class="container g-0">
      <div class="row">
        <div class="col">

          <!-- Search text -->
          <div class="input-group input-group-lg">
            <span class="input-group-text"><i class="bi bi-search"></i></span>
            <input id="searchText" type="text" name="searchText" [placeholder]="placeholder" [ngModel]="searchText" (keyup)="onSearchTextInputChange($event)" class="form-control" autocomplete="off" (focusin)="toggleSearchResultShow()">
          </div>

          <!-- Results -->
          <div class="search-results-container">
            <ul id="searchResults" class="dropdown-menu" aria-labelledby="defaultDropdown">
              <li *ngFor="let search of searches">
                <a class="dropdown-item" (click)="selectSearch(search)">
                  <i class="bi bi-geo-alt" *ngIf="search.type === 'prediction'">&nbsp;&nbsp;</i>
                  <i class="bi bi-map" *ngIf="search.type === 'region'">&nbsp;&nbsp;</i>
                  <i class="bi bi-building-fill-check" *ngIf="search.type === 'place'">&nbsp;&nbsp;</i>
                  <span>{{ search.title }}</span>
                </a>
              </li>
            </ul>

          </div>
        </div>

        <!-- Filter Toggle -->
        <div class="col-auto ps-0">
          <button class="btn btn-neon-blue ps-2 pe-2" data-bs-toggle="collapse" data-bs-target="#place-list-filter" aria-expanded="false" aria-controls="place-list-filter">
            <i class="bi bi-toggles ps-3 pe-3"></i>
            <span class="hide-sm hide-md pe-3">Filters</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
